import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    // reset both <html> and <body> scroll just in case
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    // or: window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);
  return null;
}